export const OTP_REGEX = /^[0-9]{1,6}$/;
